const iconButtonFileDownBtn = {
  title: 'Generar código qr de este equipo'
};

export default iconButtonFileDownBtn;
